//Login
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REFRESHTOKEN = "REFRESHTOKEN";

//Account
export const SWITCH_ACCOOUNT = "SWITCH_ACCOOUNT";
export const LOAD_ORGANIZATION = "LOAD_ORGANIZATION";
export const SEND_PASSWORD_RESET_LINK = "SEND_PASSWORD_RESET_LINK";
export const VERIFY_RESET_PASSWORD_LINK = "VERIFY_RESET_PASSWORD_LINK";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const LOAD_PROJECT = "LOAD_PROJECT";
export const GET_USER_TAGS = "GET_USER_TAGS";

//GPT Conversations
export const RETRIEVE_GPT_CONVERSATION_DETAIL = "RETRIEVE_GPT_CONVERSATION_DETAIL";
export const RETRIEVE_GPT_PROFILES = "RETRIEVE_GPT_PROFILES";
export const RETRIEVE_GPT_CONVERSATION_SUMMARY = "RETRIEVE_GPT_CONVERSATION_SUMMARY";
export const RETRIEVE_CONVERSATION_HISTORY = "RETRIEVE_CONVERSATION_HISTORY";

//Call
export const RETRIEVE_CALLS = "RETRIEVE_CALLS";
export const RETRIEVE_CALL_DETAILS = "RETRIEVE_CALL_DETAILS";
export const UPDATE_CALL_DETAIL = "UPDATE_CALL_DETAIL";
export const UPDATE_BULK_CALL_DETAILS = "UPDATE_BULK_CALL_DETAILS";
export const DELETE_CALL_DETAIL = "DELETE_CALL_DETAIL";
export const DELETE_BULK_CALLS = "DELETE_BULK_CALLS";

//task status
export const GET_TASK_STATUS = "GET_TASK_STATUS";

//Chorus
export const GET_CHORUS_TASK_STATUS = "GET_CHORUS_TASK_STATUS";
export const RE_RUN_CHORUS_TASK = "RE_RUN_CHORUS_TASK";
export const CREATE_TRANSCRIPTION = "CREATE_TRANSCRIPTION";

//Download
export const RETRIEVE_PRESIGNED_URL = "RETRIEVE_PRESIGNED_URL";

//generate masked version
export const GENERATE_MASKED_TRANSCRIPTION = "GENERATE_MASKED_TRANSCRIPTION";

//Save generated masked version
export const SAVE_MASKED_TRANSCRIPTION = "SAVE_MASKED_TRANSCRIPTION";
//Save generated masked version of Conversation
export const UPDATE_MASKED_CONVERSATION = "UPDATE_MASKED_CONVERSATION";

//Alert
export const ADD_ALERT = "ADD_ALERT";

//Interactions
export const UPDATE_INTERACTIONS = "UPDATE_INTERACTIONS";

//Project
export const INIT_PROJECT_CONTEXT = "INIT_PROJECT_CONTEXT";
export const SWITCH_PROJECT = "SWITCH_PROJECT";
export const RESTORE_PROJECT_CONTEXT = "RESTORE_PROJECT_CONTEXT";
export const VALIDATE_REMAINING_ENTRIES = "VALIDATE_REMAINING_ENTRIES";